export default [
    {
        path: '/customer/travel-miles/manual-addition',
        props: true,
        component: () => import('@/views/Customer/TravelMiles/ManualAddition'),
    },
];
